import React, { useState } from "react"
import { Mask } from "./index"
import { useStaticQuery, Link } from "gatsby"
import { langId } from "../languages"
import Img from "gatsby-image"
import { useIntl, FormattedMessage } from "react-intl"
import { linkConfigPro } from "../config"
import classnames from "classnames"
import { useIsLangEN, useLinkLanguage } from "../hooks"

const MenuList = ({ children, isVisible }) => {
  return (
    <div
      className={classnames({
        "menu-list": true,
        "menu-list--hide": !isVisible,
      })}
    >
      {children}
    </div>
  )
}

const Menu = ({ defaultSubMenuVisible = false, baseSlug }) => {
  const [visible, setVisible] = useState(false)
  const [submenuVisible, setSubmenuVisible] = useState(defaultSubMenuVisible)
  const intl = useIntl()
  const linkLanguage = useLinkLanguage()
  const isLangEN = useIsLangEN()
  const Images = useStaticQuery(graphql`
    query {
      menu: file(relativePath: { eq: "images/menu.png" }) {
        ...fragmentsFluidImage
      }

      btnClosePurple: file(
        relativePath: { eq: "images/btn-close-purple.png" }
      ) {
        ...fragmentsFluidImage
      }

      channel823: file(
        relativePath: { eq: "images/linkreit-channel-823-logo.png" }
      ) {
        ...fragmentsFluidImage
      }
    }
  `)
  return (
    <>
      <div className="menu" onClick={() => setVisible(!visible)}>
        <Img
          fluid={Images.menu.childImageSharp.fluid}
          alt={intl.formatMessage({ id: langId.MENU })}
          title={intl.formatMessage({ id: langId.MENU })}
        ></Img>
      </div>

      <Mask isVisible={visible}></Mask>

      <MenuList isVisible={visible}>
        <div
          className="menu-list__btn-close"
          onClick={() => setVisible(!visible)}
        >
          <Img
            fluid={Images.btnClosePurple.childImageSharp.fluid}
            alt={intl.formatMessage({ id: langId.CLOSE })}
            title={intl.formatMessage({ id: langId.CLOSE })}
          ></Img>
        </div>
        <ul>
          {linkConfigPro.map(link => (
            <li key={link.baseSlug}>
              <Link
                to={`/${intl.locale}/${
                  link.baseSlug ? link.baseSlug + "/" : ""
                }`}
                title={intl.formatMessage({ id: link.title })}
                className={classnames({
                  "menu-list__navigation": true,
                  "menu-list__navigation--en": isLangEN,
                  "menu-list__navigation--active": baseSlug === link.baseSlug,
                })}
                activeClassName="menu-list__navigation--active"
              >
                {link.subMenu && (
                  <div
                    className={classnames({
                      "menu-list__sub-menu-btn": true,
                      "menu-list__sub-menu-btn--en": isLangEN,
                    })}
                    onClick={e => {
                      e.preventDefault()
                      setSubmenuVisible(!submenuVisible)
                    }}
                  >
                    {submenuVisible ? "-" : "+"}
                  </div>
                )}
                <FormattedMessage
                  id={link.title}
                  title={intl.formatMessage({ id: link.title })}
                ></FormattedMessage>
              </Link>
              {link.subMenu && (
                <ul
                  className={classnames({
                    "menu-list__sub-menu": true,
                    "menu-list__sub-menu--hide": !submenuVisible,
                  })}
                >
                  {link.subMenu.map(sublink => (
                    <li key={sublink.baseSlug}>
                      <Link
                        to={`/${intl.locale}/${sublink.baseSlug}/`}
                        title={intl.formatMessage({ id: sublink.title })}
                        className={classnames({
                          "menu-list__navigation": true,
                          "menu-list__navigation--sub": true,
                          "menu-list__navigation--en": isLangEN,
                          "menu-list__navigation--sub-en": isLangEN,
                        })}
                        activeClassName="menu-list__navigation--active"
                        dangerouslySetInnerHTML={{
                          __html: intl.formatMessage({ id: sublink.title }),
                        }}
                      ></Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>

        <a
          className={classnames({
            "menu-list__footer": true,
            "menu-list__footer--en": isLangEN,
          })}
          href={`https://www.linkreit.com/${linkLanguage}/media/publication/?pageType=channel823`}
          rel="noopener"
          target="_blank"
          title={intl.formatMessage({ id: langId.LINK_REIT })}
        >
          <span
            className={classnames({
              "menu-list__footer__text": true,
              "menu-list__footer__text--en": isLangEN,
            })}
          >
            <FormattedMessage
              id={langId.PREVIOUS_ISSUES}
              title={intl.formatMessage({ id: langId.PREVIOUS_ISSUES })}
            ></FormattedMessage>
          </span>
          <div className="menu-list__footer__logo">
            <Img
              fluid={Images.channel823.childImageSharp.fluid}
              alt={intl.formatMessage({ id: langId.CHANNEL_823 })}
              title={intl.formatMessage({ id: langId.CHANNEL_823 })}
            ></Img>
          </div>
        </a>
      </MenuList>
    </>
  )
}

export default Menu
